export const AssetGroups = Object.freeze({
  INDIVIDUAL: "individual",
  TYPE: "type",
  CURRENCY: "currency",
})
